/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const BrandIcon = ({ width = 24, height = 24, hidden = false, title = 'Brand' } = {}):
  | string
  | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M10.00684,19c-.08398,0-.16797-.00195-.25293-.00391-4.42188-.25098-7.81836-3.90234-7.75293-8.31152V3.25c0-1.24023,1.00977-2.25,2.25-2.25h11.49902c1.24023,0,2.25,1.00977,2.25,2.25l-.00293,7.99023c-.06641,2.13965-.95898,4.12305-2.51562,5.58691-1.49609,1.40625-3.43164,2.17285-5.47461,2.17285ZM4.25098,2.5c-.41309,0-.75.33691-.75.75v7.44531c-.05371,3.61426,2.72168,6.59766,6.31934,6.80176,1.70703.05176,3.36816-.57324,4.63281-1.7627s1.99121-2.80078,2.04395-4.53711l.00293-.19727V3.25c0-.41309-.33691-.75-.75-.75H4.25098Z"
      fill="currentColor"
      stroke-width="0"
    />
    <path
      d="M14.25,12h-5.5c-.26465,0-.50977-.13965-.64453-.36719-.13574-.22754-.14062-.50977-.01367-.74219l2.75098-5.03906c.13184-.24121.38379-.39062.6582-.39062h0c.27441,0,.52734.15039.6582.39062l2.74902,5.03906c.12695.23242.12207.51465-.01367.74219-.13477.22754-.37988.36719-.64453.36719ZM10.01367,10.5h2.97266l-1.48535-2.72363-1.4873,2.72363Z"
      fill="currentColor"
      stroke-width="0"
    />
    <path
      d="M5.74902,12c-.12109,0-.24414-.0293-.3584-.0918-.36328-.19824-.49707-.6543-.29883-1.01758l1.98145-3.62891c.19727-.36328.65332-.49805,1.01758-.29883.36328.19824.49707.6543.29883,1.01758l-1.98145,3.62891c-.13574.24902-.39355.39062-.65918.39062Z"
      fill="currentColor"
      stroke-width="0"
    />
  </svg>`;
};
